// src/firebase/examSessions.js
// Student-facing read of their own in-progress exam sessions, so the
// dashboard can offer a "Continue" card for a task the student closed or
// logged out of mid-way - the timer (or unlimited-time session) keeps
// running server-side regardless; this is purely a way back into it.

import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from './config';

export const getActiveExamSessions = async (studentId) => {
  try {
    const q = query(
      collection(db, 'examSessions'),
      where('studentId', '==', studentId),
      where('status', 'in', ['not_started', 'in_progress'])
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (error) {
    console.error('Get active exam sessions error:', error);
    return [];
  }
};
